import React from 'react';
import {Grid, IconButton, Tooltip} from '@material-ui/core';
import {IconAdicionar as AddIcon, IconFiltros as FilterListIcon} from '../../components/icons/MateraIcons';

function ApontamentoTopActions (props) {
        return <Grid container direction={'column'} justifyContent={'flex-start'}>
            <Grid container direction={'row'} justifyContent={'flex-end'}>               
                <div>
                    <Tooltip title="Adicionar">
                        <IconButton aria-label="Adicionar apontamento"
                                    onClick={props.addPendencyDialog}>
                            <AddIcon/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Filtros">
                        <IconButton aria-label="Lista de filtros" onClick={props.filter}>
                            <FilterListIcon/>
                        </IconButton>
                    </Tooltip>
                </div>
            </Grid>
        </Grid>
}

export default ApontamentoTopActions;
